export * from "./lib/decorators";
export * from "./lib/stories";
export * from "./lib/ui";

if (!window[`#flex-component.version`]) {
  window["#flex-component.version"] = "2.3.3";
}

export const PACKAGE_VERSION = "2.3.1";